<template>
  <div :class="[baseCss, 'select-none']" v-if="field.label">
    <div v-html="label" :class="[field['label-divider'] ? null : 'mb-1', 'text-xs', setTextColor('labelColor', 'labelColorLightness')]" />
    <divider v-if="field['label-divider']" :class="['my-1']" />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'FormSchemaLabel',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('form-schema-label', ['select-none'])
    }
  },
  computed: {
    label () {
      const field = this.field
      return `${field.label}${field.required ? '<sup class="text-base bcq-text-field-label-required text-' + this.requiredColor + '-' + this.requiredColorLightness + '"> * </sup>' : ''}`
    }
  },
  props: {
    field: {
      type: Object,
      default: () => {
        return {}
      }
    },
    labelColor: {
      type: String
    },
    labelColorLightness: {
      type: String
    },
    requiredColor: {
      type: String
    },
    requiredColorLightness: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/form-schema/form-schema-label.vue